import Apa from './Apa';

class Asset extends Apa {}

export default new Asset();



// WEBPACK FOOTER //
// ./src/requests/apa/Asset.js